import {
  GET_USERS,
  GET_USER_BLOCK_LIST,
  ADD_USERS,
  UPDATE_USERS,
  DELETE_USERS,
  RESET_USERS,
  UPDATE_USER_ROLE,
  UPDATE_USER_ACTIVE_STATUS,
} from "../../Types";
import _ from "lodash";

const initialState = {
  getUserList: [],
  getUserBlockList: [],
  addUser: {},
};

const ManageUsersReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return { ...state, getUserList: action.payload };
    case ADD_USERS:
      return { ...state, addUser: action.payload };
    case UPDATE_USERS:
      return state.getUserList.splice(
        _.findIndex(state.getUserList, { id: action.payload.id }),
        1,
        ...action.payload
      );
    case UPDATE_USER_ACTIVE_STATUS:
      let userList = [...state.getUserList];
      let statusIndex = userList.findIndex(
        (u) => u.userName == action.payload.username
      );
      userList[statusIndex].isActive = action.payload.status;
      return { ...state, getUserList: state.getUserList };
    case GET_USER_BLOCK_LIST:
      return { ...state, getUserBlockList: action.payload };
    default:
      return state;
  }
};
export default ManageUsersReducer;
